import { createSelector } from '@reduxjs/toolkit';

import { TRootState } from '../index';
import { ICounsellorsState } from './counsellors.slice';

/**
 A selector function to retrieve the counsellors data from the store
 @function
 @param {TRootState} state - The root state of the Redux store
 @returns {ICounsellorsState} The counsellors state object from the Redux store
 */
const selectCounsellorsState = (state: TRootState): ICounsellorsState => state.counsellors;

/**
 A memoized selector function to retrieve the counsellors state from the store
 @function
 @type {import('@reduxjs/toolkit').OutputSelector<RootState, ICounsellorsState, (res: ICounsellorsState) => ICounsellorsState>}
 */
export const getCounsellorsState = createSelector(
  [selectCounsellorsState],
  (state): ICounsellorsState => state
);
